import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PendingQuotationModel, SalesModuleApiSuffixModels, loggedInUserData } from '@app/modules';
import { AppState } from '@app/reducers';
import {
    CrudService, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix,
    RxjsService, SERVER_REQUEST_DATE_TIME_TRANSFORM,
    setRequiredValidator
} from '@app/shared';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { combineLatest } from 'rxjs';
@Component({
    selector: 'quotaion-pending-pop-up',
    templateUrl: './quotation-pending-pop-up.component.html'
})

export class QuotationPendingPopUpComponent implements OnInit {
    pendingQuotationForm: FormGroup;
    loggedInUserData: LoggedInUserModel;
    probabilityOfClosures = [];
    contactDetails: any;
    conactError = false;
    todayDate = new Date();
    data;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig,
        private crudService: CrudService,
        private formBuilder: FormBuilder, private datePipe: DatePipe,
        private store: Store<AppState>, private rxjsService: RxjsService) {
        this.data = config?.data;
    }

    ngOnInit(): void {
        this.rxjsService.setDialogOpenProperty(true);
        this.combineLatestNgrxStoreData();
        this.createQuotationForm();
        this.getProbabilityOfClosures();
        this.getContactNumbers();
    }

    combineLatestNgrxStoreData() {
        combineLatest([this.store.select(loggedInUserData)]).subscribe((response) => {
            this.loggedInUserData = new LoggedInUserModel(response[0]);
        });
    }

    getProbabilityOfClosures() {
        this.crudService.get(
            ModulesBasedApiSuffix.SALES,
            SalesModuleApiSuffixModels.SALES_API_PROBABILITY_CLOSURE,
            undefined, false, null).subscribe((response: IApplicationResponse) => {
                if (response.isSuccess && response.statusCode === 200) {
                    this.probabilityOfClosures = response.resources;
                }
                this.rxjsService.setPopupLoaderProperty(false);
            });
    }

    getContactNumbers() {
        this.crudService.get(
            ModulesBasedApiSuffix.SALES,
            SalesModuleApiSuffixModels.SALES_API_LEAD_CONTACTS,
            this.data?.leadId, false, null).subscribe((response: IApplicationResponse) => {
                if (response.isSuccess && response.statusCode === 200) {
                    this.contactDetails = response.resources;
                }
                this.rxjsService.setPopupLoaderProperty(false);
            });
    }

    radioChange(e, type) {
        this.pendingQuotationForm.controls['contactNumber'].setValue(e);
        this.pendingQuotationForm.controls['contactNumberCountryCode'].setValue(type);
    }

    createQuotationForm(): void {
        let pendingQuoatationModel = new PendingQuotationModel();
        this.pendingQuotationForm = this.formBuilder.group({});
        Object.keys(pendingQuoatationModel).forEach((key) => {
            this.pendingQuotationForm.addControl(key, (key == 'createdUserId' || key == 'modifiedUserId') ? new FormControl(this.loggedInUserData.userId) :
                new FormControl(pendingQuoatationModel[key]));
        });
        this.pendingQuotationForm = setRequiredValidator(this.pendingQuotationForm, ["probabilityOfClosureId", "contactNumber", "contactNumberCountryCode", "callbackDateTime", "comments"]);
    }

    onSubmit(): void {
        this.pendingQuotationForm.value.leadId = this.data.leadId;
        this.conactError = (this.pendingQuotationForm.controls['contactNumber'].status === 'INVALID') ? true : false;
        if (this.pendingQuotationForm.invalid) return;
        this.pendingQuotationForm.value.quotationVersionId = this.data.quotationVersionId;
        this.pendingQuotationForm.value.callbackDateTime = this.datePipe.transform(this.pendingQuotationForm.value.callbackDateTime, SERVER_REQUEST_DATE_TIME_TRANSFORM);
        this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_QUOTATION_OUTCOME_PENDING, this.pendingQuotationForm.value).subscribe((response) => {
            if (response.isSuccess && response.statusCode === 200) {
                this.ref.close(true);
                this.pendingQuotationForm.reset();
            }
        });
    }

    dialogClose() {
        this.ref.close(false);
    }

    ngOnDestroy(): void {
        this.rxjsService.setDialogOpenProperty(false);
    }
}